import Vue from 'vue';
import VueRouter from 'vue-router';
import MetaInfo from 'vue-meta-info';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue';
import global_ from './components/common/Global';
import hljs from 'highlight.js';

Vue.directive('hljs', (el) => {
  const highlight = el.querySelectorAll('pre');
  highlight.forEach((block) => {
    hljs.highlightBlock(block);
  });
});

Vue.prototype.GLOBAL = global_;
Vue.config.productionTip = false;
Vue.use(Antd);
Vue.use(VueRouter);
Vue.use(MetaInfo);

const routes = [
  { path: '/', component: App },
  { path: '/p/:indexTitle', component: () => import('./components/home/PassageDetail') },
  // { path: '/tag/:tagName?', component: PassageDetail },
  { path: '/search', component: () => import('./components/home/Search') },
  { path: '/login', component: () => import('./components/home/Login') },
  { path: '/feedback', component: () => import('./components/home/Feedback') },
  { path: '/admin', component: () => import('./components/admin/Admin') },
  { path: '*', component: () => import('./components/common/NotFound') }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

new Vue({
  router
}).$mount('#app');
